import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DevModeService {
  isDevModeActive: boolean;

  constructor() { }

  checkDevMode(currentUserValue) { 
    const savedDevMode = sessionStorage.getItem('devMode');
    if (savedDevMode === 'true') {
      this.enableDevModeInternal(currentUserValue);
    }

    if (currentUserValue?.['devMode']) {
      this.isDevModeActive = true;
    }
  }

  enableDevModeInternal(currentUserValue) {
    if (currentUserValue) {
      currentUserValue['devMode'] = true;
      this.isDevModeActive = true;
    }
  }

  enableDevMode(currentUserValue) {
    if (currentUserValue) {
      currentUserValue['devMode'] = true;
      this.isDevModeActive = true;
      
      sessionStorage.setItem('devMode', 'true');
      
      setTimeout(() => {
        window.location.reload();
      }, 30);
    }
  }
  
  toggleDevMode(currentUserValue) {
    if (this.isDevModeActive) {
      this.disableDevMode(currentUserValue);
    } else {
      this.enableDevMode(currentUserValue);
    }
  }
  
  disableDevMode(currentUserValue) {
    if (currentUserValue) {
      if (currentUserValue['devMode'] == true) {
        currentUserValue['devMode'] = false;
        this.isDevModeActive = false;
        
        sessionStorage.removeItem('devMode');
        
        setTimeout(() => {
          window.location.reload();
        }, 30);
      }
    }
  }

}